import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL ?? 'http://127.0.0.1:8000/api/';


const API = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getProductListAPI = async (token) => {
    try {
        const response = await API.get('admin/products', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response.status === 401) {
            return {
                "status": false,
                "message": 'Something went wrong please try again.'
            }
        }
    }
};

export const createProductAPI = async (formData, token) => {    
    try {
        const response = await API.post('admin/products/store', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const getProductAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/products/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const updateProductAPI = async (formData, id, token) => {    
    try {
        const response = await API.post(`admin/products/update/${id}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const deleteProductAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/products/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};

export const removeProductImageAPI = async (id, token) => {    
    try {
        const response = await API.get(`admin/products/remove-image/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Message:", error.response.data.message);
        }
        throw error;
    }
};